// Recipient email is configured on the Web3Forms dashboard for this access key
// (Settings > Email Configuration > Recipient Emails), not overridden here.
const WEB3FORMS_ACCESS_KEY = 'd918d391-a184-4636-8cd7-e42c08ff5be7';
const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

export interface InquiryEmailPayload {
  name: string;
  email: string;
  company?: string;
  phone?: string;
  interest?: string;
  message?: string;
}

export interface Web3FormsResult {
  ok: boolean;
  message: string;
}

/**
 * Sends an inquiry submission to info@bekaaliglobal.com via Web3Forms.
 * Returns a normalized { ok, message } result so callers can show
 * success/error state without worrying about Web3Forms' response shape.
 */
export async function sendInquiryEmail(payload: InquiryEmailPayload): Promise<Web3FormsResult> {
  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: WEB3FORMS_ACCESS_KEY,
        subject: `New Inquiry from ${payload.name || 'Website Visitor'} - BEKAALI Website`,
        from_name: payload.name || 'BEKAALI Website',
        name: payload.name,
        email: payload.email,
        company: payload.company || '',
        phone: payload.phone || '',
        product_interest: payload.interest || '',
        message: payload.message || '',
      }),
    });

    const result = await response.json().catch(() => null);

    if (response.ok && result?.success) {
      return { ok: true, message: result?.message || 'Submitted successfully.' };
    }

    return {
      ok: false,
      message: result?.message || 'Something went wrong. Please try again.',
    };
  } catch {
    return {
      ok: false,
      message: 'Network error. Please check your connection and try again.',
    };
  }
}
